module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAgCAYAAAAv8DnQAAAAYklEQVQ4T2P8f4DBk4GRYS4DA4MkAyp4zvCfIZnx/0GGZ1gkYUqfgxT8R9OJwh0iCv7/J+ALQgqMWt7hN2FUAThdMI6GAz3DAV/mfcFo0PzOiwmS/SWQc+1/Boan//8zpAEABsNgc+9cxP4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/upmarket/title_logo.png
// module id = hZ5O
// module chunks = 1